import { Issue, useIssue } from '@gripp/shared-logic';
import {
  BottomComponentBar,
  LoadingIndicator,
  ReassignModal
} from '@gripp/shared-ui';
import { View } from 'react-native';
import { useParams } from 'react-router-dom';

export const ActivityReassignColumn = () => {
  const { issueId } = useParams();
  const { issue, isLoading } = useIssue(issueId ?? '');

  if (isLoading) {
    return (
      <LoadingIndicator />
    );
  }

  return (
    <ReassignModal
      visible={true}
      hide={() => {}}
      issue={issue as Issue}
      presentWebStyle={true}
      bottomBar={({ onRightPress: _omit, ...props }) => (
        <View style={{
          marginHorizontal: 16,
        }}>
          <BottomComponentBar {...props} backButton={null} />
        </View>
      )}
    />
  );
};